module.exports = __webpack_public_path__ + "static/media/image-card-7.fb1c9107.png";